import { NumberInput } from '@solinkcorp/solink-ui/components/NumberInput';
import { SelectItem } from '@solinkcorp/solink-ui/components/Select';
import { SimpleSelect } from '@solinkcorp/solink-ui/components/SimpleSelect';
import { Textarea } from '@solinkcorp/solink-ui/components/Textarea';
import { type FC } from 'react';
import { type DatasetExpectedOutput } from 'vd-server/db/aiDatasetSchema';
import type { OutputSchemaField } from 'vd-server/db/schema';

export const ExpectedOutputs: FC<{
  field: OutputSchemaField;
  expected?: DatasetExpectedOutput;
  onChange: (patch: Partial<DatasetExpectedOutput>) => void;
  disabled?: boolean;
}> = ({ field, expected = {}, onChange, disabled }) => {
  switch (field.type) {
    case 'number': {
      const value =
        expected.min !== undefined && expected.min === expected.max
          ? expected.min
          : (expected.min ?? expected.max);
      return (
        <NumberInput
          placeholder="Expected value"
          value={value}
          onChange={(v) => onChange({ min: v, max: v })}
          className="flex-1"
          disabled={disabled}
        />
      );
    }
    case 'percentage':
    case 'duration':
    case 'range':
      return (
        <div className="flex items-center gap-2">
          <NumberInput
            placeholder="Min"
            value={expected.min}
            onChange={(v) => onChange({ min: v })}
            className="flex-1"
            disabled={disabled}
          />
          <span className="text-foreground-secondary body-sm">to</span>
          <NumberInput
            placeholder="Max"
            value={expected.max}
            onChange={(v) => onChange({ max: v })}
            className="flex-1"
            disabled={disabled}
          />
        </div>
      );
    case 'boolean':
      return (
        <SimpleSelect
          value={
            expected.expectedBoolean === undefined ? undefined : String(expected.expectedBoolean)
          }
          onChange={(v) => onChange({ expectedBoolean: v === 'true' })}
          placeholder="Select a value"
          className="w-full"
          disabled={disabled}
        >
          <SelectItem value="true">Yes</SelectItem>
          <SelectItem value="false">No</SelectItem>
        </SimpleSelect>
      );
    case 'enum':
      return (
        <SimpleSelect
          value={expected.expectedEnum}
          onChange={(v) => onChange({ expectedEnum: v })}
          placeholder="Select a value"
          className="w-full"
          disabled={disabled}
        >
          {field.enumValues
            ?.filter((e) => e.value)
            .map(({ value }) => (
              <SelectItem key={value} value={value}>
                {value}
              </SelectItem>
            ))}
        </SimpleSelect>
      );
    case 'string':
      return (
        <Textarea
          placeholder="Expected value"
          value={expected.expectedValue ?? ''}
          onChange={(e) => onChange({ expectedValue: e.target.value })}
          disabled={disabled}
        />
      );
    default:
      return null;
  }
};
